import styled from "styled-components"
import { device } from "breakpoints"
import { getGradientText } from "helpers/getGradientText"
import { Carousel } from "components/Carousel"
import {
  Controls,
  Dots,
  Buttons,
  SlidesContainer,
  NextButton,
  PreviousButton,
  EmblaComponent,
} from "components/Carousel/style"
import { MainColumn } from "components/MainColumn"
import AvenueImg from "components/AvenueImg"

export const NeighbourhoodsContainer = styled(MainColumn)`
  display: flex;
  margin: ${props => `${props.theme.componentMargin.mobile}px auto`};
  @media ${device.desktop} {
    margin: ${props => `${props.theme.componentMargin.desktop}px auto`};
  }

  @media ${device.large} {
    margin: ${props => `${props.theme.componentMargin.large}px auto`};
  }

  h2 {
    ${props => getGradientText("live")};
    font-size: 33px;

    @media (min-width: 386px) {
      font-size: 36px;
    }
    @media ${device.desktop} {
      margin-bottom: 30px;
      font-size: 42px;
    }
    @media ${device.large} {
      margin-bottom: 45px;
    }
  }
`

export const MapSvg = styled.svg`
  height: auto;
  width: 100%;
  margin-left: auto;
  overflow: visible !important;
  display: none;

  @media ${device.tablet} {
    display: block;
    transform: translateY(-30px);
  }

  @media ${device.desktop} {
    transform: translateY(-30px);
  }
  @media ${device.large} {
    transform: translateY(-55px);
  }
`

export const Dot = styled.g`
  opacity: 0;
  transition: 300ms;
`

export const Land = styled.path`
  transform: translateY(0px) scale(1);
  transition: 300ms;
  z-index: 0;
`

export const LandWrapper = styled.g`
  cursor: pointer;
  transition: 300ms;
  box-shadow: 10px 15px 35px 0 rgba(0, 0, 0, 0.35);
  z-index: 0;

  > use {
    opacity: 0;
    transition: 300ms;
  }

  /* ${props =>
    props.active &&
    `
    > use {
      opacity: 1;
    }

    ${Dot} {
      opacity: 1;
    }

    ${Land} {
      transform: translateY(-9px) scale(1.05);
    }
 `}; */

  &.active {
    > use {
      opacity: 1;
    }

    ${Dot} {
      opacity: 1;
    }

    ${Land} {
      transform: translateY(-9px) scale(1.05);
    }
  }

  :hover {
    ${Dot} {
      opacity: ${props => (props.active ? 1 : 0.6)};
    }
  }
`

export const CBD = styled.g`
  pointer-events: none;
`

export const OverlappedCarousel = styled(Carousel)`
  position: relative;
  width: 100%;

  ${EmblaComponent} {
    pointer-events: all;
  }
  ${SlidesContainer} {
    height: auto;
    padding-top: 63.45646% !important;

    :before {
      content: "";
      background-image: linear-gradient(
        6deg,
        rgba(0, 0, 0, 0.65) 18%,
        rgba(0, 0, 0, 0) 50%
      );
      position: absolute;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 2;
      bottom: 0;
    }
  }
  ${Controls} {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 3;
    pointer-events:none;
    height: 100%;
    /* display: none; */
  }

  ${Buttons} {
    display: none;
    pointer-events:all;

    @media ${device.tablet} {
      display: flex;
      position: absolute;
      bottom: 60px;
      left: 20px;
    }

    @media ${device.desktop} {
      bottom: 90px;
      left: 40px;
    }
  }

  ${NextButton} {
    background: none;
    height: 42px;
    width: 42px;
    border: 2px solid white;
    @media ${device.desktop} {
      height: 48px;
      width: 48px;
    }
  }

  ${PreviousButton} {
    margin-right: 10px;
  }

  ${Dots} {
    position: absolute;
    right: 20px;
    bottom: 20px;
    pointer-events:all;

    @media ${device.desktop} {
      bottom: 40px;
      right: 35px;
    }
  }
`

export const SlideImg = styled(AvenueImg)`
  position: absolute !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`
export const CarouselTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const DescriptionText = styled.div`
  position: relative;
  margin-top: 28px;
  z-index: 3;

  @media ${device.desktop} {
    margin-top: 40px;
  }
  h3 {
    font-size: 18px;
    color: black;
    text-transform: uppercase;
    margin-bottom: 15px;
    font-weight: 600;
    @media ${device.tablet} {
      font-size: 22px;
      color: white;
      position: absolute;
      left: 20px;
      top: -70px;
    }
    @media ${device.desktop} {
      font-size: 28px;
      top: -107px;
      left: 40px;
    }
  }

  p {
    font-size: 16px;
    height: 170px;

    @media ${device.mobile} {
      height: 145px;
    }

    @media ${device.tablet} {
      height: 115px;
    }
    @media ${device.desktop} {
      font-size: 20px;

      height: 100px;
    }

    @media ${device.large} {
      height: 110px;
    }
  }
`
